const backImage =
  "https://readdy.ai/api/search-image?query=editorial-flat-vector-illustration-of-an-open-case-file-and-notebook-on-a-desk-with-magnifying-glass-timeline-chart-magnified-fingerprint-and-scattered-paper-notes-with-connection-lines-between-keywords-editorial-flat-vector-illustration-on-warm-cream-paper-background-with-terracotta-red-and-deep-melon-green-accent-palette-thin-elegant-line-art-with-subtle-paper-grain-magazine-cover-aesthetic-soft-minimal-composition-generous-negative-space-no-text-no-watermark&width=820&height=700&orientation=portrait&seq=gw51-behind-01";

const details = [
  {
    no: "01",
    title: "时间线上，缺了「消失的 48 小时」",
    text: "机构在 06-26 至 06-28 之间整整沉默了两天。对照主播直播回放与预告片，我们发现那 48 小时里双方明显在拉扯——声明里的克制，其实是谈崩之后的退让。",
  },
  {
    no: "02",
    title: "措辞里藏着态度曲线",
    text: "从「遗憾」到「深表遗憾」，从「沟通」到「多次沟通」。把官方文案放在一起比，称呼的松动速度，远比声明本身更能说明问题。",
  },
  {
    no: "03",
    title: "那句「口头承诺」，从未被正面回答",
    text: "反转录像里最有分量的一句，两家声明都没正面回应。避而不谈，本身就是一种回答——这也是事件至今仍未真正翻篇的原因。",
  },
];

export default function BehindScene() {
  return (
    <section id="neimu" className="mx-auto max-w-[1240px] scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
        <div>
          <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
            <i className="ri-focus-3-line h-4 w-4" />
            深扒幕后 · 编辑手记
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            三处最容易被忽略的<span className="text-primary-600">内幕细节</span>
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-7 text-foreground-600 md:text-base">
            公告、直播回放、旧录像，我们把能拿到的材料逐帧对照，挖出了三段没上热搜、却最能解释全局的幕后细节。
          </p>

          <div className="mt-8 space-y-4">
            {details.map((d) => (
              <article
                key={d.no}
                className="flex gap-5 rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="font-heading text-2xl font-black text-primary-300 md:text-3xl">{d.no}</span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{d.title}</h3>
                  <p className="mt-1.5 text-sm leading-7 text-foreground-600">{d.text}</p>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href="#laiqu"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-time-line h-4 w-4" />
              回看时间线核对
            </a>
            <span className="text-xs text-foreground-500">以上细节均标注原始来源日期，可自行对照复核</span>
          </div>
        </div>

        <div className="lg:pt-10">
          <figure className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <img
              src={backImage}
              alt="五1吃瓜事件内幕幕后细节深挖档案配图"
              className="h-[260px] w-full object-cover md:h-[340px]"
            />
            <figcaption className="flex items-center justify-between gap-3 px-5 py-4">
              <div>
                <p className="flex items-center gap-1.5 text-sm font-medium text-foreground-900">
                  <i className="ri-question-answer-line h-4 w-4 text-accent-600" />
                  我们这样深挖
                </p>
                <p className="mt-1 text-xs leading-5 text-foreground-500">
                  材料口径：公告 ×2 · 直播回放 ×14 · 旧录像 ×1 · 商务记录（节选）
                </p>
              </div>
              <button
                type="button"
                className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-xs font-medium text-background-50 transition hover:bg-secondary-600"
              >
                <i className="ri-file-download-line h-4 w-4" />
                下载材料索引
              </button>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}